var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 0.833008H4.16658L6.39992 11.9913C6.47612 12.375 6.68484 12.7196 6.98954 12.9649C7.29424 13.2102 7.6755 13.3405 8.06658 13.333H16.1666C16.5577 13.3405 16.9389 13.2102 17.2436 12.9649C17.5483 12.7196 17.757 12.375 17.8333 11.9913L19.1666 4.99967H4.99992M8.33325 17.4997C8.33325 17.9599 7.96016 18.333 7.49992 18.333C7.03968 18.333 6.66658 17.9599 6.66658 17.4997C6.66658 17.0394 7.03968 16.6663 7.49992 16.6663C7.96016 16.6663 8.33325 17.0394 8.33325 17.4997ZM17.4999 17.4997C17.4999 17.9599 17.1268 18.333 16.6666 18.333C16.2063 18.333 15.8333 17.9599 15.8333 17.4997C15.8333 17.0394 16.2063 16.6663 16.6666 16.6663C17.1268 16.6663 17.4999 17.0394 17.4999 17.4997Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.bb1e51a121b5bc8f03eeed3fc84eed1a.svg";
export { ForwardRef as ReactComponent };